import type { DocPresenceKey, DocViewer } from "@productlane/lib"
import { AvatarStack, Tooltip } from "@productlane/ui"

import { useDocViewers } from "@/lib/use-doc-presence"

const MAX_SHOWN = 3

export function viewersLabel(viewers: DocViewer[]): string {
	const names = viewers.map((viewer) => viewer.name)
	if (names.length <= 1) return `${names[0] ?? ""} is viewing`
	const last = names.pop()
	return `${names.join(", ")} and ${last} are viewing`
}

/** Teammates who have the same thread, changelog entry or article open. */
export function DocViewers({ docKey }: { docKey: DocPresenceKey }) {
	const viewers = useDocViewers(docKey)
	if (viewers.length === 0) return null
	const hidden = viewers.length - MAX_SHOWN

	return (
		<Tooltip label={viewersLabel(viewers)}>
			<div className="flex flex-none items-center gap-1 px-1">
				<AvatarStack
					avatars={viewers.map((viewer) => ({
						name: viewer.name,
						image: viewer.imageUrl,
					}))}
					slice={MAX_SHOWN}
					size="xs"
				/>
				{hidden > 0 && (
					<span className="text-xs tabular-nums text-gray-500 dark:text-gray-400">
						+{hidden}
					</span>
				)}
			</div>
		</Tooltip>
	)
}
